<template>
  <div class="listings">
    <!-- Title and Header -->
    <div class="listings__title">
      <h2 class="medium-title">Your Listings</h2>
    </div>
    <div class="listings__header">
      <div class="listings__header__left">
        <i class="adx-ic_search"></i>
        <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
      </div>
      <div class="listings__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <!-- Listings -->
    <div class="listings__content">
      <div>
        <table>
          <thead class="none">
            <tr>
              <td class="header1">PLACES</td>
              <td class="header1">PLACEMENT</td>
              <td class="header2">CAMPAIGN</td>
              <td></td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in items" :key="index" @click.stop="gotoDetail(item)" class="content">
              <td class="places">
                <div class="item">
                  <img v-if="item.primary_photo" :src="item.primary_photo" alt="">
                  <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
                  <div class="stack">
                    <span class="stack__top">{{ item.location_name }}, {{ item.cluster }}</span>
                    <span class="stack__bottom">{{ item.property_type_display }} • {{ item.city_name }}</span>
                  </div>
                </div>
              </td>
              <td class="placement">{{ item.placement }}</td>
              <td v-if="item.campaign_count == 1" class="campaign">{{ item.campaign_count }} Active Campaign</td>
              <td v-else-if="item.campaign_count > 1" class="campaign">{{ item.campaign_count }} Active Campaigns</td>
              <td v-else class="campaign">No campaign yet</td>
              <td class="viewDetail">
                <button v-if="item.campaign_count > 0" class="btn-small secondary" @click.stop="select(item)">View Detail</button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Pagination -->
        <div class="pagination" v-if="!isLoading && !isEmpty"><adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/></div>
        <!-- Loading State -->
        <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div>
        <!-- Empty State -->
        <div class="emptyState"><adx-empty-selection v-if="isEmpty && !loading" /></div>
      </div>
    </div>
    <!-- Modal -->
    <adx-modal v-if="isOpen" @modal-close="toggle">
      <div slot="content">
        <div class="listings__modal">
          <p class="location">{{ selectedRow.location_name }}</p>
          <p class="placement">{{ selectedRow.placement }}</p>
          <p v-if="selectedRow.campaign_count == 1" class="active">{{ selectedRow.campaign_count }} Active Campaign</p>
          <p v-else class="active">{{ selectedRow.campaign_count }} Active Campaigns</p>
          <div v-if="!isLoadingModal" class="listings__modal__content">
            <table>
              <thead class="none">
                <tr>
                  <td class="header">CAMPAIGN</td>
                  <td class="header">PERIOD</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(detail, index) in details.results" :key="index" class="content">
                  <td class="places">{{ detail.title }}</td>
                  <td class="placement">{{ dateFormat(detail.start) }} - {{ dateFormat(detail.end) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Loading State -->
          <div class="loadingState"><adx-loading v-if="isLoadingModal" slot="loading" /></div>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
// Components
import SideBar from '@/components/SideBar/Desktop'
import DropdownSort from '@/components/Form/SelectDropdown'
import Modal from '@/components/Modal'
import types from '@/lib/types'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'

// Api
import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
import { formatShortDate } from '@/lib/util'

const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-host-listings',
  components: {
    'adx-sidebar': SideBar,
    'adx-dropdown-sort': DropdownSort,
    'adx-modal': Modal,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
  },
  data() {
    return {
      isOpen: false,
      sort: [
        {
          'id': 0,
          'label': 'Last Added',
          'value': '-created'
        },
        {
          'id': 1,
          'label': 'First Added',
          'value': 'created'
        },
        {
          'id': 2,
          'label': 'Name',
          'value': 'location_inside__title'
        },
      ],
      selectedSortValue: '-created',
      searchBoxValue: '',
      selectedRow: null,
      isInit: true,
      isLoading: false,
      isLoadingModal: false,
      isEmpty: false,
      details: [],
      selectedPage: 1,
      maxPage: 0,
      items: [],
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        ordering: this.selectedSortValue || undefined,
        search: this.searchBoxValue || undefined
      }
      this.$router.replace({
        query: params
      })
      return params
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.initalLoad()
      })
    }, 500),
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedSortValue = newValue
        this.initalLoad()
      }
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    if (this.$route.query.page) {
      this.selectedPage = this.$route.query.page
    }
    this.initalLoad()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    initalLoad(isInit = null) {
      (async () => {
        this.$data.isLoading = true
        this.isEmpty = false
        let params = {
          page: this.selectedPage,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.dashboardHostListings, { needToken: true, params })
        if (!data.count && this.searchBoxValue) {
          this.isEmpty = true
        } else {
          this.items = data.results
          this.maxPage = data.max_page
          // Just check max page once
          // if (this.maxPage == 0) {
          //   if (data.count % this.items.length > 0) {
          //     this.maxPage = Math.floor(data.count / this.items.length) + 1
          //   } else {
          //     this.maxPage = Math.floor(data.count / this.items.length)
          //   }
          // }
        }
        this.$data.isLoading = false
      })();
    },
    select(item) {
      (async () => {
        this.$data.isLoadingModal = true
        this.details = []
        this.selectedRow = item
        const { data } = await api.get(apiV2.dashboardHostDetail(item.pub_id), { needToken: true})
        this.details = data
        this.$data.isLoadingModal = false
      })();
      this.toggle()
    },
    selectPage(item) {
      this.selectedPage = item
      this.initalLoad()
    },
    dateFormat(date) {
      return formatShortDate(date)
    },
    gotoDetail(item) {
      if (item.pub_id) {
        const { pub_id, category_display } = item
        let url
        switch (category_display) {
          case 'malls':
            url = this.$router.resolve({ name: 'detailmall', params: { pub_id }})
            break
          case 'lifestyle':
            url = this.$router.resolve({ name: 'detaillifestyle', params: { pub_id }})
            break
          case 'spbu':
            url = this.$router.resolve({ name: 'detailspbu', params: { pub_id }})
            break
          case 'airport':
            url = this.$router.resolve({ name: 'detailairport', params: { pub_id }})
            break
          default:
            url = this.$router.resolve({ name: 'home' })
        }
        window.open(url.href, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
